import React, { Component, PropTypes } from "react"
import { connect } from "react-redux"
import { Fieldset } from "react-gridforms"
import { actions } from "react-redux-form/immutable"
import Table from "react-bootstrap/lib/Table"

import withRequests from "./hocs/withRequests"
import ListStudentItem from "./list-student-item"

class FormStudents extends Component {
  _onCheckAll = e => {
    const { model, dispatch } = this.props
    const checked = e.target.checked

    // loop through students. check those not submitted
    model.map((item, k) => {
      if (!item.getIn(["grade_submission_id", "Valid"])) {
        dispatch(
          actions.change(`classState.students[${k}].is_checked`, checked)
        )
      }
      return true
    })
  }

  _focusNext = (k, term) => {
    const { model, dispatch } = this.props
    if (term === "mt") {
      term = "ft"
    } else if (term === "ft") {
      term = "re"
    } else if (term === "re") {
      term = "mt"
      k++
    }
    if (k === model.size) {
      k = 0
    }

    // focus
    dispatch(actions.focus(`classState.students[${k}].${term}`))
  }

  render() {
    const {
      model,
      offeringGroupID,
      openConfirmUnlock,
      openConfirmCancelUnlock,
    } = this.props
    return (
      <Fieldset legend="Students Enrolled">
        <Table hover bordered condensed className="grade">
          <thead>
            <tr>
              <th width="3%" className="text-center">
                <input type="checkbox" onChange={this._onCheckAll} />
              </th>
              <th width="3%">#</th>
              <th width="10%">ID #</th>
              <th width="5%">Stat</th>
              <th>NAME OF STUDENT</th>
              <th width="5%" className="text-right">
                MT
              </th>
              <th width="5%" className="text-right">
                FT
              </th>
              <th width="5%" className="text-right active">
                FG
              </th>
              <th width="5%" className="text-right">
                RE
              </th>
            </tr>
          </thead>
          <tbody>
            {model.map((item, k) => (
              <ListStudentItem
                key={k}
                item={item}
                k={k}
                offeringGroupID={offeringGroupID}
                focusNext={this._focusNext}
                openConfirmUnlock={openConfirmUnlock}
                openConfirmCancelUnlock={openConfirmCancelUnlock}
              />
            ))}
          </tbody>
        </Table>
      </Fieldset>
    )
  }
}

FormStudents.propTypes = {
  model: PropTypes.object,
  offeringGroupID: PropTypes.string,
}

export default connect()(withRequests(FormStudents))



// WEBPACK FOOTER //
// ./src/containers/Grades/form-students.js